import Vue from 'vue'
import ElementUI from 'element-ui'
import '@/assets/styles/element-variables.scss'

Vue.use(ElementUI, { size: 'small' })
